import Http from "./Http";

export class PolicySettingsService extends Http {
  /**
   * Get policy-settings
   */
  getPolicySettings() {
    return this.get("/policy-settings");
  }

  /**
   * Update policy-settings
   * @param {Array} body
   */
  updatePolicySettings(body) {
    return this.put("/policy-settings", body);
  }
}

export default new PolicySettingsService();
